import {
	Select,
	Text,
	Textarea,
	Upload,
	Number,
	FormGroupInterface,
	VALIDATION_TYPE,
	S3URLS,
	DDate
} from 'projects/common/src/app/types';
import { COURSE_JOB_ROLE_MAPPING_TYPE } from 'projects/training-partner/src/app/training-partner/constants/string.constant';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
interface IData {
	sectorsOptions?: any;
	jobRoleMappingTypeOptions?: any;
	jobRolesOptions?: any;
	nsqfLevelsOptions?: any;
	repositryOptions?: any;
	minimumAgeOptions?: any;
	minimumEducationRequiredOptions?: any;
	minimumEducationRequired?: any;
	gradingPreferencesOptions?: any;
	minimumEducationRequiredValue?: any;
	daysInfo?: any;
	submitText?: string;
	cancelText?: string;
	stage?: any;
}
export function getAddCourse(
	data: IData = {},
	on: any = {}
): FormGroupInterface {
	const addCourse: FormGroupInterface = {
		label: 'Add Course to Sectors',
		backButton: true,
		submitText: data.submitText,
		cancelText: data.cancelText,
		forms: [
			{
				label: 'Course Details Info:',
				// name: 'details',
				formElements: [
					new Select('Sector:', data.sectorsOptions || [], {
						name: 'sectorName',
						required: true,
						asyncLoad: true,
						onChange: on.sectorChange,
						showAstrisk: true
					}),
					new Select(
						'Job Role Mapping Type:',
						[COURSE_JOB_ROLE_MAPPING_TYPE.QP_NOS, COURSE_JOB_ROLE_MAPPING_TYPE.OTHERS],
						// data.jobRoleMappingTypeOptions || ['QP-NOS', 'Others'],
						{
							name: 'jobRoleMappingType',
							required: true,
							onChange: on.jobRoleMappingChange,
							showAstrisk: true
						}
					),
					new Select(
						'Associated QP/Job Role Name:',
						data.jobRolesOptions || [],
						{
							name: 'jobRoleName',
							required: true,
							onChange: on.jobRoleChange,
							asyncLoad: true,
							showAstrisk: true
						}
					),
					new Select(
						'Expository:',
						data.repositryOptions || [],
						{
							name: 'expository',
							multi: true,
							hide: true,
							required: true,
							metainfo: 'For multiple select use Ctrl + Click or Drag using the mouse',
							showAstrisk: true
							// onChange: on.jobRole,
						}
					),
					new Text('Course Name:', {
						required: true,
						// metainfo: 'Please enter Course name',
						name: 'course',
						// validationType: VALIDATION_TYPE.COURSE_NAME,
						showAstrisk: true
					}),
					new Select('NSQF Level:', data.nsqfLevelsOptions || [], {
						name: 'nsqfLevel',
						validationName: 'Nsqf Level',
						required: true,
						showAstrisk: true,
						disabled: true
					}),
					new Textarea('Course Description:', {
						name: 'description',
						required: true,
						showAstrisk: true
						// validationType: VALIDATION_TYPE.COURSE_DESCRIPTION
					})
				]
			},
			{
				label: 'Course Parameters:',
				// name: 'courseParameters',
				formElements: [
					new Text('Name of the Certificate Issued:', {
						name: 'issuedCertificateName',
						// metainfo: 'Please enter name of the certificate issued',
						validationType: VALIDATION_TYPE.DESCRIPTION
					}),
					new Select('Minimum Age:', getMinimumAge(14, 99), {
						// data.minimumAgeOptions || [], {
						name: 'minimumAge',
						placeholder: 'Select minimum age of the candidate',
						required: true,
						showAstrisk: true
					}),
					new Select(
						'Minimum Education Required:',
						data.minimumEducationRequiredOptions || [],
						{
							validationName: 'Minimum Education',
							name: 'minimumEducationRequired',
							required: true,
							showAstrisk: true,
							asyncLoad: true,
							// hide: data.stage && data.stage === 'update' ? true : false
						}
					),
					// new Text('Minimum Education Required:', {
					// 	name: 'minimumEducationRequiredValue',
					// 	validationType: VALIDATION_TYPE.DESCRIPTION,
					// 	showAstrisk: true,
					// 	// readOnly: true,
					// 	hide: data.stage && data.stage === 'update' ? false : true,

					// }),
					// new Text('Course Duration', {
					// 	placeholder: 'Enter Course Duration in Days, Months or Years',
					// 	required: true,
					// 	name: 'courseDurationInDays',
					// 	validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
					// 	charAllowedPattern: '[0-9]',
					// 	maxFieldLength: 30,
					// 	// pattern: '[^0][A-Za-z0-9 .]*'
					// }),
					new Text('Course Duration(In Hours)', {
						required: true,
						name: 'courseDurationInHours',
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						charAllowedPattern: '[0-9]',
						maxFieldLength: 20,
						showAstrisk: true
						// pattern: '[^0][A-Za-z0-9 .]*'
					}),
					new Number('Number of Hours per day', {
						placeholder: 'Enter Number of Hours per day',
						required: true,
						name: 'hoursPerDay',
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						max: 8,
						metainfo: data.daysInfo,
						min: 1,
						maxFieldLength: 1,
						showAstrisk: true
					}),
					new Number('Course Fee:', {
						required: true,
						name: 'courseFee',
						validationType: VALIDATION_TYPE.POSITIVE_NUMBER,
						min: 0,
						max: 9999999,
						maxFieldLength: 7,
						showAstrisk: true
					}),
					new Select(
						'Grading Preferences:',
						// ['CGPA', 'Percentage', 'Grade', 'Marks'],
						['Grade'],
						// data.gradingPreferencesOptions || [],
						{
							name: 'gradingPreferences',
							required: true,
							showAstrisk: true
						}
					),
					new DDate(
						'Course Validity:',
						{
							name: 'couseValidity',
							emitInDateFormat: true,
							placeholder: 'Select Date',
							minDate: (() => {
								const currentDate = new Date()
								Helpers.makeTimeZero(currentDate)
								return currentDate;
							})(),
							readOnly: true,
						}
					)
				]
			},
			{
				label: 'Upload Undertaking Documents:',
				formElements: [
					// new Upload('Course Approval Documents:', {
					// 	name: 'supportingDocuments',
					// 	multi: true,
					// 	// required: true,
					// 	documentTemplateUrl: S3URLS.COURSE.FUNDED.QPNOS_AVAIL,
					// 	isPublicUrl: true,
					// 	allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					// }),
					// new Upload('Upload Affiliation Certificates from SSC:', {
					// 	name: 'affiliationCertificatesFromSSC',
					// 	multi: true,
					// 	// required: true,
					// 	allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					// }),
					// new Upload('Upload Work Order:', {
					// 	name: 'workOrder',
					// 	multi: true,
					// 	allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					// }),
					// new Upload('Upload Challan of the Fee Paid:', {
					// 	name: 'challanOfFeePaid',
					// 	multi: true,
					// 	allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					// }),
					new Upload('Upload Stamp paper with Self Declaration:', {
						name: 'stampPaperWithSelfDeclaration',
						// documentTemplateUrl: S3URLS.COURSE.FUNDED.QPNOS_AVAIL,
						multi: true,
						required: true,
						isPublicUrl: true,
						showAstrisk: true,
						allowedFormats: ['pdf', 'jpeg', 'png', 'jpg', 'xlsx']
					})
				]
			},
			{
				label: 'Thumbnail:',
				formElements: [
					new Upload('Upload Thumbnail:', {
						name: 'thumbnail',
						maxSize: 1,
						required: true,
						showAstrisk: true,
						viewImage: true,
						onChange: on.thumbnailImageChange,
						allowedFormats: ['jpeg', 'png', 'jpg']
					})
				]
			}
		]
	};
	return addCourse;
}

function getMinimumAge(from, till) {
	const result = [];
	for (let i = from; i <= till; i++) {
		result.push(i);
	}
	return result;
}
